var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.43 15V9c0-3.1 2.04-3.75 3.75-3.75s3.75.65 3.75 3.75v6c0 3.1-2.04 3.75-3.75 3.75s-3.75-.65-3.75-3.75zm1.5-6v6c0 1.62.63 2.25 2.25 2.25s2.25-.63 2.25-2.25V9c0-1.62-.63-2.25-2.25-2.25s-2.25.63-2.25 2.25zM3.07 15V9c0-3.1 2.04-3.75 3.75-3.75s3.75.65 3.75 3.75v6c0 3.1-2.04 3.75-3.75 3.75S3.07 18.1 3.07 15zm1.5-6v6c0 1.62.63 2.25 2.25 2.25s2.25-.63 2.25-2.25V9c0-1.62-.63-2.25-2.25-2.25S4.57 7.38 4.57 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.36a.749.749 0 1 1 0 1.5H9.82zM21.75 14.5v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM.75 14.5v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineWeight);
export default __webpack_public_path__ + "static/media/vuesax-outline-weight.da5e0fb5d4f6e977269b8deb644d1dd2.svg";
export { ForwardRef as ReactComponent };